import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdb802b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-wrapper__overlay" }, null, -1))
const _hoisted_3 = { class: "modal-wrapper__content" }
const _hoisted_4 = { class: "modal-wrapper__header" }

import CloseIcon from "@/icons/common/close-icon.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  title: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const router = useRouter();



const close = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
        _createElementVNode("a", {
          class: "modal-wrapper__header-close",
          onClick: close
        }, [
          _createVNode(CloseIcon)
        ])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})